import apiClient from './apiClient';
import { config } from '../config';

const API_URL = config.apiUrl;

export interface ZenGeneratePartPayload {
  partId: string;
  partTitle: string;
  minMinutes: number;
  maxMinutes: number;
  popularOptions: string[];
  customInstructions?: string;
  isSelfGuided: boolean;
}

export interface ZenScriptResponse {
  title: string;
  description: string;
  image_prompt: string;
  parts: Array<{ partId: string; text: string }>;
  cost: number;
}

export interface ZenEditPartPayload {
  partId: string;
  partTitle: string;
  text: string;
}

export interface ZenMixResponse {
  success: boolean;
  audioMixData: any;
  summary: string;
  cost: number;
}

/**
 * Intelligent Zen Mode API. 402 responses carry { error, cost, currentBalance }
 * — callers surface them for coin-shortfall UX.
 */
// AI generation can take minutes — override the apiClient's default 30s timeout.
const LONG_TIMEOUT = { timeout: 5 * 60 * 1000 };

class ZenService {
  async generateScript(goal: string, language: string, parts: ZenGeneratePartPayload[]): Promise<ZenScriptResponse> {
    const response = await apiClient.post(`${API_URL}/zen/generate-script`, { goal, language, parts }, LONG_TIMEOUT);
    return response.data;
  }

  async editScript(payload: {
    goal: string;
    instruction: string;
    title: string;
    description: string;
    image_prompt: string;
    parts: ZenEditPartPayload[];
  }): Promise<ZenScriptResponse> {
    const response = await apiClient.post(`${API_URL}/zen/edit-script`, payload, LONG_TIMEOUT);
    return response.data;
  }

  async generateMix(scriptId: string): Promise<ZenMixResponse> {
    const response = await apiClient.post(`${API_URL}/zen/generate-mix`, { scriptId }, LONG_TIMEOUT);
    return response.data;
  }
}

export const zenService = new ZenService();
